import { Spinner } from "@flixbus/honeycomb-react";
import { DefaultInfoAlert } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { useIntl } from "react-intl";
import { getContractPartner } from "../../helpers/selectedContractPartner/selectedContractPartner";
import * as css from "./BookingDataAccessCheck.scss";
import { FindPartnerQueryVariables, useFindPartnerQuery } from "./api/operations.generated";
import NoBookingDataAccessAllowedMessage from "./ui/noBookingDataAccessAllowedMessage/NoBookingDataAccessAllowedMessage";

type Props = {
  LoadingAnimation?: React.ReactElement;
};

const BookingDataAccessCheck: React.FC<Props> = ({
  children,
  LoadingAnimation = (
    <div className={css.wrapper}>
      <Spinner />
    </div>
  ),
}) => {
  const { formatMessage } = useIntl();

  const vars: FindPartnerQueryVariables = {
    contractPartnerId: getContractPartner().contractPartnerId,
  };

  const { data, loading, error } = useFindPartnerQuery({
    variables: vars,
  });

  if (loading) {
    return LoadingAnimation;
  }

  if (data?.findPartner) {
    const partnerData = data.findPartner;

    if (!partnerData.bookingDataAccessAllowed) {
      return <NoBookingDataAccessAllowedMessage />;
    }

    return <>{children}</>;
  }

  if (error) {
    if (error.message.includes("No partner found")) {
      return <NoBookingDataAccessAllowedMessage />;
    }
    return (
      <DefaultInfoAlert
        message={formatMessage({
          id: "general.findMarketplacePartnerQuery",
        })}
      />
    );
  }

  return <></>;
};

export default BookingDataAccessCheck;
